import React from 'react'
import PropTypes from 'prop-types'

import { Message } from './style'

const ErrorMessage = ({ message, children }) => (
  <Message error>{message}</Message>
)

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
}

export { ErrorMessage }
